import { render, staticRenderFns } from "./InitiateDocument.vue?vue&type=template&id=7e90ccc5&"
import script from "./InitiateDocument.vue?vue&type=script&lang=js&"
export * from "./InitiateDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports